import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSIntroRunner implements SimplePresentation {

    private static superFSIntroClosedCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

    public shouldRun(): boolean {
        return ((TheBorder.model.data.mode == TheBorderGameMode.NORMAL || TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE)
                && TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN) ||
            ((TheBorder.model.data.mode == TheBorderGameMode.FREESPIN || TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE)
                && TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN);
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: gsap.core.Timeline = gsap.timeline();
        mainTL.add(() => {
            TheBorder.isInFS = true;
        });
        if (TheBorder.model.data.mode == TheBorderGameMode.NORMAL || TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE) {
            mainTL.add(() => {
                TheBorder.superFSIntroView.showSuperFSIntro(() => TheBorderSuperFSIntroRunner.superFSIntroClosedCallback(controller), false);

                if (TheBorder.IS_BOOSTED_BET_ON) {
                    TheBorder.xRipReelHighlighter.stopHighlight();
                }
            });
        } else {
            mainTL.add(() => {
                TheBorder.fsToSuperFSIntroView.showSuperFSIntro(() => TheBorderSuperFSIntroRunner.superFSIntroClosedCallback(controller), true);
            });
        }
    }
}